export default __webpack_public_path__ + "static/media/Wheel-Orange.53dfc760.png";